import { Component, Input, OnInit } from '@angular/core';
import { AuthorizationService, CoreService, LoaderService, LoggingService, PortalService } from 'src/app/services';
import { TopNotificationService } from 'src/app/shared/components/top-notification/top-notification.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IDelegateTraining, IPortalConfig, IUserTraining, NotificationType } from 'src/app/models';
import { environment } from 'src/environments/environment';
import { Helpers } from 'src/app/helpers';
import _ from 'lodash';
import { TrainingService } from 'src/app/services/training.service';
import { Response } from '../../../models/response';

@Component({
    selector: 'medpt-delegate-training-others',
    templateUrl: './delegate-training-others.component.html',
    styleUrl: './delegate-training-others.component.scss',
    standalone: false
})
export class DelegateTrainingOthersComponent implements OnInit {

  @Input() public DelegateTrainingInputData!: IDelegateTraining;

  protected defaultItem = { DisplayName: '-- Select a User --', UserID: '' };
  protected delegateform!: FormGroup;
  private DelegateSignerUserList: any[] = [];
  protected userFilteredData: any[] = [];
  protected DelegateFormSubmitted: boolean = false;
  protected userPortalInfo: IPortalConfig;
  protected cdnEndPoint = environment.cdnEndPoint;
  protected isRequiredTrainingDelegated: boolean = false;

  constructor(
    private portalService: PortalService,
    private loaderService: LoaderService,
    private loggingService: LoggingService,
    private authorizationService: AuthorizationService,
    private notificationService: TopNotificationService,
    private trainingService: TrainingService,
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private coreservice: CoreService,
  ) {
    this.userPortalInfo = this.portalService.portalConfiguation.value;
  }

  ngOnInit() {
    this.isRequiredTrainingDelegated = _.filter(this.DelegateTrainingInputData.Assets, (item) => item.IsRequired == true).length > 0;
    this.delegateform = this.formBuilder.group({
      Reason: ['', [Validators.required, Validators.maxLength(2500)]],
      DelegateTrainingList: this.formBuilder.array(this.DelegateTrainingInputData.Assets.map((data: IUserTraining) => this.createUserFormGroup(data))),
      MakeDelegateTrainingOptional: new FormControl({
        value: this.isRequiredTrainingDelegated ? true : false, disabled: !this.DelegateTrainingInputData.DelegateUser.IsRequired
      }),
      WaiverTrainingToCurrentUser: [false],
      SendEmailNotification: [false],
    });

    if (this.DelegateTrainingInputData.Assets.length > 0) {
      this.OpenDelegateTrainingModal();
    }
  }

  createUserFormGroup(asset: IUserTraining): FormGroup {
    
    return this.formBuilder.group({
      ActivityAssetId: [asset.AssetID, Validators.required],
      ModuleAssetId: [asset.MA_AssetID, Validators.required],
      DelegatedUserId: ['', [Validators.required]]
    });
  }

  protected OpenDelegateTrainingModal() {

    this.loaderService.showLoader();
    this.loggingService.Info(
      `<MedPoint.WebApp.TriPort.MyTraining.SiteTraining.GetUserSignerListForRoleType> begins.`
    );
    this.coreservice
      .getSiteUsers(this.userPortalInfo.SponsorName!, this.userPortalInfo.PortalID!, this.DelegateTrainingInputData.SiteID)
      .then((response: any[]) => {
        if (response != null) {
          response = _.filter(response, (item) => { return item.UserID != this.DelegateTrainingInputData.DelegateUser.UserId; });
          response = _.map(response, (item) => { item.DisplayName = Helpers.decodeEntity(item.FirstName) + " " + Helpers.decodeEntity(item.LastName); return item; });
          this.DelegateSignerUserList = this.userFilteredData = response;
        }
      })
      .catch((err) => {
        this.loggingService.Error(
          `<MedPoint.WebApp.TriPort.MyTraining.SiteTraining.GetUserSignerListForRoleType> Failed with message=${JSON.stringify(err)}`
        );
        this.notificationService.showNotification("Failed to get delegate user list.", NotificationType.Error);
      })
      .finally(() => {
        this.loaderService.hideLoader();
        this.loggingService.Info(
          `<MedPoint.WebApp.TriPort.MyTraining.SiteTraining.GetUserSignerListForRoleType> ends.`
        );
      });
  }

  get users() {
    return this.delegateform.get('DelegateTrainingList') as FormArray;
  }

  protected SubmitDelegatedInfo() {
    this.DelegateFormSubmitted = true;
    if (this.delegateform.valid) {
      this.loaderService.showLoader();
      let postData = this.delegateform.value;
      postData.DelegateeUserID = this.DelegateTrainingInputData.DelegateUser.UserId;
      let errorMessage = "Training delegation failed. Please retry or contact MedPoint help desk.";
      this.trainingService.UpdateDelegateUser(<string>this.userPortalInfo.SponsorName, <number>this.userPortalInfo.PortalID, postData).then(
        (res: Response) => {
          if (res.Success) {
            this.notificationService.showNotification("Training delegated successfully.", NotificationType.Success);
            this.modal.close({ Success:true, WaiverTrainingToCurrentUser: this.delegateform.value.WaiverTrainingToCurrentUser, MakeDelegateTrainingOptional: this.delegateform.value.MakeDelegateTrainingOptional,DelegateTrainingList:res.Data });
          } else {
            this.notificationService.showNotification(errorMessage, NotificationType.Error);
          }
        },
        () => {
          this.notificationService.showNotification(errorMessage, NotificationType.Error);
        }
      ).catch(() => {
        this.notificationService.showNotification(errorMessage, NotificationType.Error);
      })
        .finally(() => {
          this.loaderService.hideLoader();
        });
    } else {
      this.users.markAllAsTouched();
    }
  }

  public filterData(filter: any): void {
    this.userFilteredData = this.DelegateTrainingInputData.Assets.length > 0 ? this.DelegateSignerUserList.filter((s: any) => s.DisplayName.toLowerCase().indexOf(filter.toLowerCase()) !== -1) : [];
  }
}
